import axiosUserInstance from '@/helpers/http-common';

/* eslint-disable no-shadow */
const state = () => ({
  token: localStorage.getItem('jwt') || null,
  status: '',
});

// getters
const getters = {
  isAuthenticated: state => !!state.token,
};

  // actions
const actions = {
  login: (
    { commit, dispatch, rootState },
    { email, password },
  ) => new Promise((resolve, reject) => {
    commit('loginLoading');

    axiosUserInstance.post('auth/login', {
      email,
      password,
      device: rootState.device.platform,
      uuid: rootState.device.uuid,
    })
      .then((response) => {
        dispatch('firebaseAnalytics/setLogin', { method: 'smilekiosk' }, { root: true });
        dispatch('loginSuccess', { accessToken: response.data.access_token, user: response.data.user }).finally(() => {
          resolve(response);
        });
      })
      .catch((error) => {
        reject(error);

        commit('loginError');
      });
  }),
  logout({ commit, dispatch }, { forced = false } = { forced: false }) {
    if (!forced) {
      axiosUserInstance.post('auth/logout', { });
    }

    localStorage.removeItem('jwt');
    axiosUserInstance.defaults.headers.Authorization = null;

    commit('logout');
    dispatch('user/removeUser', {}, { root: true });
    dispatch('userContests/removeContests', {}, { root: true });
  },
  socialLogin: (
    { commit, dispatch, rootState },
    { token, provider = 'facebook', givenName = null, familyName = null },
  ) => new Promise((resolve, reject) => {
    commit('loginLoading');

    axiosUserInstance.post('auth/login-social', {
      provider,
      token,
      givenName,
      familyName,
      device: rootState.device.platform,
      uuid: rootState.device.uuid,
      marketingLink: rootState.branch.initBranchLink,
    })
      .then((response) => {
        dispatch('firebaseAnalytics/setLogin', { method: provider }, { root: true });
        dispatch('loginSuccess', { accessToken: response.data.access_token, user: response.data.user }).finally(() => {
          resolve(response);
        });
      })
      .catch((error) => {
        reject(error);

        commit('loginError');
      });
  }),
  socialFirebaseXGoogleLogin: (
    { commit, dispatch, rootState }, { idToken },
  ) => new Promise((resolve, reject) => {
    commit('loginLoading');

    axiosUserInstance.post('auth/login-social-google', {
      provider: 'google',
      idToken,
      device: rootState.device.platform,
      uuid: rootState.device.uuid,
    })
      .then((response) => {
        dispatch('loginSuccess', { accessToken: response.data.access_token, user: response.data.user }).finally(() => {
          resolve(response);
        });
      })
      .catch((error) => {
        reject(error);

        commit('loginError');
      });
  }),
  loginSuccess: ({ commit, dispatch }, { accessToken, user }) => new Promise((resolve) => {
    axiosUserInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
    dispatch('referrals/init', {}, { root: true }).then().catch().finally(() => {
      localStorage.setItem('jwt', accessToken);

      dispatch('user/setUserFromLogin', user, { root: true });
      commit('loginSuccess', accessToken);

      dispatch('device/syncAppDeviceDetails', {}, { root: true });
      dispatch('firebase/syncFirebaseDetails', {}, { root: true });
      dispatch('firebaseAnalytics/setUser', { userId: user.id }, { root: true });

      resolve();
    });
  }),
};

  // mutations
const mutations = {
  loginLoading(state) {
    state.status = 'loading';
  },
  loginSuccess(state, token) {
    state.status = 'success';
    state.token = token;
  },
  loginError(state) {
    state.status = 'error';
  },
  logout(state) {
    state.token = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js